import React, { Component } from 'react';  
import '../styling/Home.css';

export default class Home extends Component {
  render() {
    return (

  <div className='homePage'>

  <div className='headerContainerHome'>

  <h1><i>Odyssey: The Net Art of Space</i></h1> 
  </div>

  <div className='bodyHome'>
      <h2>Hello There, Traveler!</h2>
      <p>
        I see you have found me. <br></br>
        I would like to help you explore, for space is a vast and mighty place. <br></br>
        Let's start small. It is a bit overwhelming. 
      </p>

      <p>
        We're going to look at our very own solar system and a few of our important planets. <br></br>
        Mind you, every planet is important. They all matter. <br></br>
        And they are <i>matter</i>. Haha!
      </p>
</div>
</div>

     
    )
  }
}

